/**
 * Подключаем Vue библиотеки
 */

/**
 * Подключение обычных компонентов
 */

/** Index Page*/
AppVue.setComponent(require('./vueComponents/sliders/ProductsSlider.vue').default);

AppVue.setComponent(require('./vueComponents/catalog/head-section-modef.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/filter/index.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/filter/block.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/filter/priceSlider.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/filter/submenu.vue').default);
AppVue.setComponent(require('./vueComponents/breadcrumb.vue').default);
AppVue.setComponent(require('./vueComponents/top_menu.vue').default);
AppVue.setComponent(require('./vueComponents/menu/HeaderMenu.vue').default);
AppVue.setComponent(require('./vueComponents/top_banner.vue').default);
AppVue.setComponent(require('./vueComponents/smollSearch.vue').default);
AppVue.setComponent(require('./vueComponents/ticker.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/product/sizeGrid.vue').default);
AppVue.setComponent(require('./vueComponents/catalog/product/Viewed/ProductsViewed.vue').default);

AppVue.setComponent(require('./vueComponents/personal/personalfavorites.vue').default);
AppVue.setComponent(require('./vueComponents/personal/smsAuth.vue').default);

AppVue.setComponent(require('./vueComponents/shops/list/shops_list_block.vue').default);
AppVue.setComponent(require('./vueComponents/shops/list/shops_list_item.vue').default);
AppVue.setComponent(require('./vueComponents/shops/detail/shops_detail_block.vue').default);
AppVue.setComponent(require('./vueComponents/shops/shops_best.vue').default);
AppVue.setComponent(require('./vueComponents/shops/detail/reviews/shop_reviews_block.vue').default);
AppVue.setComponent(require('./vueComponents/shops/detail/reviews/shops_detail_reviewform.vue').default);
AppVue.setComponent(require('./vueComponents/shops/detail/reviews/shop_reviews_item.vue').default);

AppVue.setComponent(require('./vueComponents/SmallBasket/quantityBlock.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/smallBasket.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/smollBasket.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/buy_one_click.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefRadioCheckout/DefRadioCheckout.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/checkout.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/confirmPhone.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/input/order_checkbox.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/input/order_text.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/input/order_select.vue').default);
AppVue.setComponent(require('./vueComponents/checkout/input/order_autocompliteItem.vue').default);

/** seo **/
//AppVue.setComponent(require('./vueComponents/Seo/SeoText.vue').default);

/** Def **/
AppVue.setComponent(require('./vueComponents/Def/DefContent/DefContent.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefLink/DefLink.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefButtonSecondary/DefButtonSecondary.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefButtonPrimary/DefButtonPrimary.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefInput/DefInput.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefEmail/DefEmail.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefRating/DefRating.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefSlider/DefSlider.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefSlideModal/DefSlideModal.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefAnimations/DefFade.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefAnimations/DefSlideLeft.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefAnimations/DefSlideRight.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefDarkenBackground/DefDarkenBackground.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefImg/DefImg.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefPrice/DefPrice.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefPriceOld/DefPriceOld.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefH/DefH2.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefTitle/DefTitle.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefIndexTitle/DefIndexTitle.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefLabels/DefLabels.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefVideo/DefVideo.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefPicture/DefPicture.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefScrollTo/DefScrollTo.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefBuy/DefBuy.vue').default);
AppVue.setComponent(require('./vueComponents/Def/DefTextarea/DefTextarea.vue').default);


/** Product */
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReviews.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReviewsTitle.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReview.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReviewAuthor.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReviewText.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/Modal/ProductReviewModal.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/Modal/ProductReviewGuestModal.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/Modal/ProductReviewSuccessModal.vue').default);
AppVue.setComponent(require('./vueComponents/Product/Reviews/ProductReviewItem.vue').default);
AppVue.setComponent(require('./vueComponents/Product/ProductFeedBack/ProductFeedBack.vue').default);
AppVue.setComponent(require('./vueComponents/Product/ProductNotAvailable.vue').default);
AppVue.setComponent(require('./vueComponents/Product/ProductServices.vue').default);

/** Sliders */
AppVue.setComponent(require('./vueComponents/sliders/SectionsTagsSlider.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/SimilarInteresting/SimilarSlider.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/SimilarInteresting/InterestingSlider.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/SimilarInteresting/SimilarInteresting.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/SimilarInteresting/SimilarInterestingHeader.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/ProductsCategories.vue').default);
AppVue.setComponent(require('./vueComponents/sliders/BuyComplectSlider.vue').default);
AppVue.setComponent(require('./vueComponents/SmallBasket/BuyComplect.vue').default);


/** cards **/
AppVue.setComponent(require('./vueComponents/card/SliderCard/SliderCard.vue').default);
AppVue.setComponent(require('./vueComponents/card/SectionTagCard/SectionTagCard.vue').default);

/** pages */
AppVue.setComponent(require('./vueComponents/pages/Page404.vue').default);


AppVue.setComponent(require('./vueComponents/forms/contacts.vue').default);

/** Reviews page **/
AppVue.setComponent(require('./vueComponents/Reviews/form.vue').default);
AppVue.setComponent(require('./vueComponents/Reviews/list.vue').default);